/* global GoogleTagManager dataLayer */

'use strict';

import $ from 'jquery';
import debounce from 'lodash/debounce';
import objectPath from 'object-path';
import cloneDeep from 'lodash/cloneDeep';
import utils from '../util';
import * as cart from '../api/cart';
import headerCart from '../checkout/header-cart';
import slickLightbox from '../vendor/slick-lightbox';
import '../vendor/slick-carousel';
//import dynamicContentModal from '../ui/dynamic-content-modal';
//import videoModal from '../ui/video-modal';
import ImageZoomPan from '../ui/image-zoom-pan';
import productClickAndCollect from './click-and-collect';
import productDropShipping from './drop-shipping';
import trackPages from '../util/track-pages';
import { productListItems } from '../product/product-list';
import { productCarousel, customPagination } from '../product/product-carousel';
import dateCountdown from '../ui/date-countdown';
import tabs from '../ui/tabs';
import Loop54Connector from '../search/loop54-connector';

export default function (
	selector,
	{ skipSizeUpdate = false, hideGallery = false } = {}
) {
	const loop54Connector = new Loop54Connector();
	const $product = $(selector);

	const $window = $(window);
	const $document = $(document);
	const $body = $('body');

	//const $product = $('.v4-product-card');
	const $images = $product.find('.product-images');
	const $thumbs = $product.find('.product-thumbs');
	const $productForms = $product.find('.product-form');

	// Detect if there's a touch support
	let hasTouchSupport = false;
	$window.on('touchstart', function () {
		hasTouchSupport = true;
	});

	slickLightbox();
	//dynamicContentModal();
	//videoModal();
	if (!skipSizeUpdate) {
		$productForms.each(function () {
			updateProductSizes($(this));
		});
	}
	productImages();
	$productForms.each(function () {
		productFormEvents($(this));
	});
	accordion();

	if (!$body.hasClass('page-tilaus')) {
		productClickAndCollect();
	}

	productDropShipping();
	addCampaignClasses($('.product-carousel'));
	dataLayerEvents();
	dateCountdown();
	// Get carousel after everything else has been loaded

	$window.on('load', function () {
		addRecentlyViewedProductsCarousel();
		addRelatedEntitiesCarousel();
		addComplementaryEntitiesCarousel();
	});
	resetImagesAndThumbs();

	/**
	 * updateProductSizes
	 */
	function updateProductSizes($form) {
		const sapTitlenumber = $form.data('sapTitlenumber');
		const sapColor = $form.find('[type="hidden"][name="color"]')?.val() || false;

		const extraSaleProduct = $form.hasClass('extra-sale-product')
			? 'extraSaleProduct'
			: 'default';
		const iceHockeyStickProduct = $form.hasClass('ice-hockey-stick-product')
			? 'iceHockeyStickProduct'
			: 'default';
		const $container = $form.find('.product-sizes-list-container');

		addFormLoader($form);

		const getParams = {
			productId: sapTitlenumber,
			extraSaleProduct,
			iceHockeyStickProduct,
		};

		if (sapColor) {
			getParams.productColor = sapColor;
		}

		$.ajax({
			data: getParams,
			dataType: 'json',
			method: 'GET',
			timeout: 30000,
			url: '/stage-ajax/productSizesListById/',
		})
			.done(function (response) {
				if (response && response.html) {
					const productSizesElem = $form.find('.product-sizes');
					const isExtraSaleProduct = $form.hasClass('extra-sale-product');

					const $selectedColor = isExtraSaleProduct
						? $form.find('[type="hidden"][name*="color"][data-page-variant="true"], [name*="color"]')
						: $form.find('[name*="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]');

					const selectedColorValue = $selectedColor.val();
					const selectedSizeName = $form
						.find('[name*="ean"]:checked')
						.data('name');

					$container.html(response.html);
					tabs(); // Re initialize tabs for ice hockey sticks

					const $newSelectedSize = $form
						.find(
							'.product-sizes-list[data-color="' + selectedColorValue + '"]'
						)
						.find('[name*="ean"][data-name="' + selectedSizeName + '"]');

					if ($newSelectedSize.length) {
						$newSelectedSize.prop('checked', true);
					}

					$selectedColor.trigger('productColorChange');

					productSizesElem.toggleClass('hidden', response.isOneSize);

					// Update extra product sizes class if exists
					const oldExtraClass = productSizesElem.data('extraclass');
					if (oldExtraClass) {
						// Remove old
						productSizesElem.removeClass(oldExtraClass);
					}

					if (response.extraClass) {
						// Add new
						productSizesElem.addClass(response.extraClass);
					}

					// Update product name if changes based on variation
					if (response.customProductName) {
						$('.js-product-name').text(response.customProductName);
					}

					if (isExtraSaleProduct && response.isOneSize) {
						$form.find('.product-sizes-list').addClass('one-size');
					}
				}
			})
			.fail(function (xhr) {
				// if (xhr && xhr.statusText !== 'abort') {
				// 	$container.append($('<p>', { text: 'Tuotekokojen latauksessa tapahtui virhe!' }));
				// }
			})
			.always(function (xhr) {
				removeFormLoader($form);
			});
	}

	/**
	 * productImages
	 */
	function productImages() {
		const slickOptions = {
			arrows: false,
			dots: false,
			fade: true,
			infinite: false,
			asNavFor: '.product-thumbs',
			lazyLoad: 'ondemand',
			prevArrow: $images.next().find('.prev'),
			nextArrow: $images.next().find('.next'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						asNavFor: false,
						fade: false,
						arrows: true,
					},
				},
			],
			speed: 200,
		};

		$images.slick(slickOptions).on({
			init: function (event, slick, currentSlide, nextSlide) {
				customPagination(event, slick, currentSlide, nextSlide, $images);
			},
			reInit: function (event, slick, currentSlide, nextSlide) {
				if (!hideGallery) {
					// Hide thumbs/dots when only one image (and no video)
					let slidesCount = slick.$slides.length;
					if ($('.product-thumbs-video-button').length) {
						slidesCount++;
					}
					$images
						.siblings('.custom-pagination')
						.toggleClass('hidden', slidesCount <= 1);
					$thumbs.toggleClass('hide-slick-thumbs', slidesCount <= 1);
				}
				customPagination(event, slick, currentSlide, nextSlide, $images);
			},
			afterChange: function (event, slick, currentSlide, nextSlide) {
				customPagination(event, slick, currentSlide, nextSlide, $images);
			},
		});

		$images
			.slickLightbox({
				background: '#fff',
				imageMaxHeight: 1,
				itemSelector: 'picture.product-images-slide',
				useHistoryApi: true,
				lazy: true,
				layouts: {
					closeButton:
						'<button type="button" class="slick-lightbox-close"><span class="close-icon"></span></button>',
				},
				slick: {
					arrows: true,
					asNavFor: '.product-images, .product-thumbs',
					dots: false,
					fade: true,
					infinite: false,
					slidesToScroll: 1,
					lazyLoad: 'ondemand',
					prevArrow: '.slick-lightbox-inner .custom-pagination .prev',
					nextArrow: '.slick-lightbox-inner .custom-pagination .next',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								arrows: false,
								fade: false,
								slidesToScroll: 1,
							},
						},
					],
					speed: 200,
				},
				src: function (element) {
					return $(element).find('img').data('lightbox-image');
				},
			})
			.on({
				setPosition: function () {
					setImagesSlideHeight();
				},
				beforeChange: function (event, slick, currentSlide, nextSlide) {
					setActiveThumbClass(nextSlide);
				},
				'show.slickLightbox': function () {
					$body.addClass('slick-lightbox-open');
					$('.slick-lightbox').addClass('v4-typography');

					/* add class '.slick-lightbox-slick-img' to safari browser to fix issue with images */
					const imageElement = document.querySelector(
						'.slick-lightbox-slick-img'
					);
					const isSafari =
						navigator.userAgent.indexOf('Safari') > -1 &&
						!(navigator.userAgent.indexOf('Chrome') > -1);

					if (isSafari) {
						imageElement?.classList.add('slick-lightbox-image-safari');
					}

					const $slickLightbox = $images[0].slickLightbox.slick;
					const $slickLightboxSlick = $slickLightbox[0].slick;
					$slickLightbox
						.siblings('.custom-pagination')
						.toggleClass('hidden', $slickLightboxSlick.slideCount <= 1);

					$slickLightbox.find('.slick-lightbox-slick-item').each(function () {
						const $img = $(this).find('img');
						new ImageZoomPan($img[0]);

						$img.on('zoomChange', function (e) {
							const currentZoom = e.originalEvent.detail.currentZoom;
							const slickEnabled = currentZoom > 1 ? false : true;

							if ($slickLightboxSlick.slideCount > 1) {
								$slickLightbox
									.siblings('.custom-pagination')
									.toggleClass('hidden', !slickEnabled);
							}

							$slickLightbox.slick(
								'slickSetOption',
								{
									accessibility: slickEnabled,
									draggable: slickEnabled,
									swipe: slickEnabled,
									touchMove: slickEnabled,
								},
								false
							);
						});
					});

					$slickLightbox.on(
						'init reInit afterChange',
						(event, slick, currentSlide, nextSlide) => {
							customPagination(
								event,
								slick,
								currentSlide,
								nextSlide,
								$slickLightbox
							);
						}
					);
				},
				'shown.slickLightbox': function (event, nextSlide) {
					const $slickLightbox = $images[0].slickLightbox.slick;
					const $slickLightboxSlick = $slickLightbox[0].slick;
					customPagination(
						event,
						$slickLightboxSlick,
						$slickLightboxSlick.currentSlide,
						nextSlide,
						$slickLightbox
					);
				},
				'hide.slickLightbox': function () {
					$body.removeClass('slick-lightbox-open');
				},
			});

		$thumbs
			.slick({
				arrows: true,
				centerMode: false,
				dots: false,
				focusOnSelect: false,
				infinite: false,
				lazyLoad: 'ondemand',
				nextArrow: '<div class="slick-prev-button"></div>',
				prevArrow: '<div class="slick-next-button"></div>',
				slidesToScroll: 1,
				slidesToShow: 7,
				swipeToSlide: false,
				variableWidth: true,
			})
			.on('click', '.product-thumbs-slide', function () {
				$images.slick('slickGoTo', $(this).index());
			});

		$window.on(
			'resize',
			debounce(function () {
				resetImagesAndThumbs();
			}, 500)
		);

		$product
			.find('.product-colors-list-item')
			.on('mouseenter', function () {
				if (!isSingleColumn() && !hasTouchSupport) {
					var $this = $(this);

					// if ($this.find('input:not(:checked)').length) {
					if ($this.find('img').length) {
						const imageSrc = $this.data('imageBig');

						if (imageSrc) {
							const $currentSlide = $images.find(
								'.product-images-slide.slick-current'
							);

							if (
								!$currentSlide.find('.product-images-preview-overlay').length
							) {
								$('<div>', {
									class: 'product-images-preview-overlay',
								}).appendTo($currentSlide);
							}

							const previewImage = new Image();

							previewImage.onload = function () {
								if ($this.filter(':hover').length) {
									$currentSlide
										.find('.product-images-preview-overlay')
										.css({ backgroundImage: `url(${imageSrc})` });
									$images.addClass('show-preview-overlay');
								}
							};

							previewImage.src = imageSrc;
						}
					}
				}
			})
			.on('mouseleave', function () {
				$images.removeClass('show-preview-overlay');
			})
			.on('touchend', function () {
				// Some touch devices may trigger mouseenter event but not mouseleave, so here we have a fix for that
				setTimeout(function () {
					$images.removeClass('show-preview-overlay');
				}, 100);
			});

		$thumbs.addClass('thumbs-loaded');
	}

	/**
	 * productForm
	 */
	function productFormEvents($form) {
		$form.on('change productColorChange', '[name*="color"]', function (e) {
			const colorCode = $(this).val();
			const colorName = $(this).data('name');
			const extraSaleProduct = $form.hasClass('extra-sale-product');
			const $selectedColorSizes = $form.find(
				'.product-sizes-list[data-color="' + colorCode + '"]'
			);
			const $selectedSize = extraSaleProduct
				? $form.find('[name*="ean"] option:selected')
				: $form.find('[name*="ean"]:checked');
			const $newSelectedSize = $selectedColorSizes.find(
				'[name*="ean"][data-name="' + $selectedSize.data('name') + '"]'
			);

			if (colorCode && colorName) {
				// update url with selected color
				const url = new URL(window.location.href);
				url.searchParams.set('color', colorCode);
				window.history.replaceState({}, '', url);

				// update header canonical url meta data to the new url
				const canonicalUrl = document.querySelector('link[rel="canonical"]');
				if (canonicalUrl) {
					canonicalUrl.setAttribute('href', url);
				}

				// update page title with selected color
				updatePageTitle(colorName);
			}

			clearFormMessages($form);

			$form.find('.product-sizes-list').addClass('hidden');
			$selectedColorSizes.removeClass('hidden');

			$form.find('.product-colors-current-color').text(colorName);

			$product.trigger('selectColor', [colorName]);

			if ($selectedSize.length && $newSelectedSize.length) {
				$selectedSize.prop('checked', false);
				$newSelectedSize.prop('checked', true).trigger('change');

				// DISABLED:
				// updateImagesOverylayText($newSelectedSize.closest('.product-sizes-list-item').find('.product-form-tooltip').text());
			} else {
				$form.find('.add-to-cart-button').toggleClass('disabled', false);

				const ccButton = $form.find('.click-and-collect-button');
				if (ccButton) {
					const sellingEnabled = ccButton.data('selling-enabled') === '1';
					if (sellingEnabled) {
						ccButton.toggleClass('disabled', false);
					}
				}

				// DISABLED:
				// updateImagesOverylayText($this.closest('.product-colors-list-item').find('.product-form-tooltip').text());
			}

			if (extraSaleProduct) {
				const productThumb = $form
					.find('[name*="color"] option:selected')
					.data('thumb');
				$form.find('.product-image img').attr('src', productThumb);
			}

			if (e.type === 'change') {
				resetImagesAndThumbs();
			}
		});

		if ($form.hasClass('extra-sale-product')) {
			$form.find('[name*="color"]').trigger('change');
		} else {
			$form.find('[name*="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]').trigger('change');
		}

		// user changes color
		$form.on('change', '.product-colors [name="color"]', function (e) {
			pushProductDetailViewToDatalayer($form);
		});

		$form.on('change', '[name*="ean"]', function () {
			const $this = $(this);

			const {
				availableInWeb,
				availableInStores,
				availableForPreorder,
				isLastOfSize,
				iceHockeyFlex,
				price,
			} = $this.data();

			const selectedColorValue = $form.find('[name*="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]').val();
			const $addToCartBtn = $form.find('.buy-button');
			const $bikeLeasingBtn = $form.find('.leasing-bike-button');
			const $preorderBtn = $form.find('.preorder-button');
			const $clickAndCollectBtn = $form.find('.click-and-collect-button');
			const $preorderInfo = $form.find('#product-preorder-info-container');

			clearFormMessages($form);

			$product.trigger('selectSize', [
				{
					size: $this.data('name'),
					ean: $this.val(),
				},
			]);

			if (
				$this.closest(
					'.product-sizes-list[data-color="' + selectedColorValue + '"]'
				).length
			) {
				$addToCartBtn.toggleClass('disabled', !availableInWeb);
				$addToCartBtn.toggleClass('hidden', availableForPreorder);
				$preorderBtn.toggleClass('hidden', !availableForPreorder);
				$preorderInfo.toggleClass('hidden', !availableForPreorder);

				$form.find('input[name="preorder"]').val(+availableForPreorder);
				$clickAndCollectBtn.toggleClass('disabled', !availableInStores);

				if (!availableInWeb && !availableForPreorder && $addToCartBtn.length && $bikeLeasingBtn.length === 0) {
					showFormMessage($addToCartBtn.data('disabledInfoText'), false, $form);
				} else if (isLastOfSize) {
					showFormMessage($form.data('lastOfSizeText'), true, $form);
				} else if (!availableInStores && $clickAndCollectBtn.length) {
					// DISABLED:
					// showFormMessage($clickAndCollectBtn.data('disabledInfoText'), true);
				}

				// DISABLED:
				// updateImagesOverylayText($this.closest('.product-sizes-list-item').find('.product-form-tooltip').text());

				// Update info based on variation if available
				if (typeof iceHockeyFlex !== 'undefined' && iceHockeyFlex) {
					$('.additional-field-value--jaykkyys-flex').text(iceHockeyFlex);
				}
				// Update price based on variation if available
				if (typeof price !== 'undefined' && price) {
					$product.find('.js-product-price').text(price + ' €');
				}
			} else {
				$addToCartBtn.toggleClass('disabled', false);
				$clickAndCollectBtn.toggleClass('disabled', false);

				// DISABLED:
				// updateImagesOverylayText('');
			}
		});

		$form.on(
			'click',
			'.add-to-cart-button, .click-and-collect-button, .drop-shipping-button',
			function (e) {
				const $this = $(this);
				let selectedColorValue;
				let checked;
				let selected;

				if ($form.hasClass('extra-sale-product')) {
					selectedColorValue = $form.find('.product-colors-list').val();
					selected = $form.find('[name*="ean"]:visible').val();
				} else {
					selectedColorValue = $form.find('[name*="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]').val();
					checked = $form
						.find('[name*="ean"]:checked')
						.closest(
							'.product-sizes-list[data-color="' + selectedColorValue + '"]'
						).length;
				}

				if (checked > 0 || selected) {
					if ($this.hasClass('disabled')) {
						showFormMessage($this.data('disabledInfoText'), false, $form);
						e.preventDefault();
					}
				} else {
					showFormMessage($form.data('sizeInfoText'), true, $form);
					e.preventDefault();
				}
			}
		);

		$form.on('submit', function (e) {
			const $submit = $form.find('button[type="submit"]');
			const amount = $form.find('input[name="amount"]').val();
			const ean = $form.hasClass('extra-sale-product')
				? $form.find('select[name="ean"]:visible').val()
				: $form.find('input[name="ean"]:checked').val();
			const preorder = $form.find('input[name="preorder"]').val() || false;
			const formErrorMessage = $form.data('formErrorText');

			$submit.prop('disabled', true);
			clearFormMessages($form);
			addFormLoader($form);

			const additional = {};
			const eans = [ean];
			$form.find('input[name="question[]"]').each((index, el) => {
				const $el = $(el);
				switch ($el.data('type')) {
					case 'number':
						additional[$el.data('label')] = el.value + ' ' + $el.data('unit');
						break;
					case 'boolean':
						additional[$el.data('label')] = el.checked ? 'kyllä' : 'ei';
						if (el.checked && $el.data('ean')) {
							eans.push($el.data('ean'));
						}
						break;
					default:
						additional[$el.data('label')] = el.value;
						break;
				}
			});

			cart
				.addItem(eans, amount, '', additional, preorder)
				.then(function (response) {
					if (response && response.result === 1) {
						headerCart.updateHeaderCart(
							true,
							response.cart,
							false,
							response.itemId
						);
						/*showFormMessage(formSuccessMessage, null, $form); Removed because there is no need for the message (we have already popup of items added to cart */

						const {
							sapTitlenumber,
							productName,
							brandName,
							sports,
							targetgroup,
							saleProduct,
							productType,
							carousel,
							searchWords,
						} = $form.data();

						const $selectedColor = $form.find('input[name="color"]:checked');
						const colorName = $selectedColor.data('name');
						const colorValue = $selectedColor.val();
						const price = parseFloat(
							$product.find('.product-price-current').text()
						);

						GoogleTagManager.addToCart(
							sapTitlenumber,
							ean,
							amount,
							colorName,
							colorValue,
							productName,
							brandName,
							$form.data('category-path'),
							sports,
							targetgroup,
							$form.data('full-category-path'),
							price,
							saleProduct,
							productType,
							carousel,
							searchWords
						);

						if ($form.hasClass('extra-sale-product')) {
							GoogleTagManager.extraSaleAddToCart(productName);
						}

						return true;
					} else if (
						response &&
						response.messages &&
						response.messages.length
					) {
						showFormMessage(response.messages[0].message, true, $form);
					} else {
						showFormMessage(formErrorMessage, true, $form);
					}
					return false;
				})
				.catch(function (error) {
					return showFormMessage(formErrorMessage, true, $form);
				})
				.finally(function () {
					removeFormLoader($form);
					$submit.prop('disabled', false);
				});

			e.preventDefault();
		});

		// Unselect radio when changing tabs
		$form[0].addEventListener(
			'tab.open',
			function (e) {
				const selectedSize = $form.find('[name*="ean"]:checked');
				if (selectedSize.length) {
					const sizeParent = selectedSize.closest('#' + e.detail.contentId);
					if (!sizeParent.length) {
						selectedSize.prop('checked', false);

						// Clear form messages
						clearFormMessages($form);

						// Reset button styles
						const $addToCartBtn = $form.find('.buy-button');
						const $clickAndCollectBtn = $form.find('.click-and-collect-button');

						$addToCartBtn.toggleClass('disabled', false);
						$clickAndCollectBtn.toggleClass('disabled', false);
					}
				}
			},
			false
		);
	}

	/**
	 * addFormLoader
	 */
	function addFormLoader($form) {
		const $formAlertContainer = $form.find('.product-alert-container');

		removeFormLoader($form);

		$('<div>', { class: 'product-form-loader' })
			.append($('<div>', { class: 'spinner-loader-circle' }))
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' })
			)
			.appendTo($formAlertContainer);
	}

	/**
	 * Update document title and og:title with selected color. Selected color is added in bracket to the end of the title.
	 * If there already is a color in the title at the end, it is replaced with the new one.
	 *
	 * @param {string} colorName
	 * @returns {void}
	 */
	function updatePageTitle(colorName) {
		// get document title text and add colorName in brackets to the end, like this "[colorName]". If there already is a color in the title in brackets, it is replaced with the new one. If there isn't it is added. Also update og:title meta tag with new content.
		const title = document.title;
		const titleWithoutColor = title.replace(/ \[.*\]$/, '');
		const newTitle = titleWithoutColor + ' [' + colorName + ']';
		document.title = newTitle;
		const ogTitle = document.querySelector('meta[property="og:title"]');

		if (ogTitle) {
			ogTitle.setAttribute('content', newTitle);
		}
	}

	/**
	 * removeFormLoader
	 */
	function removeFormLoader($form) {
		const $formAlertContainer = $form.find('.product-alert-container');
		$formAlertContainer.find('.product-form-loader').remove();
	}

	/**
	 * showFormMessage
	 *
	 * @param {String} msg
	 * @param {Boolean} isError
	 */
	function showFormMessage(msg, isError, $form) {
		const $formAlertContainer = $form.find('.product-alert-container');

		clearFormMessages($form);
		$('<div>', {
			class: `notification mb-4 ${isError ? 'is-danger' : 'is-warning'}`,
			text: msg,
		}).appendTo($formAlertContainer);
	}

	/**
	 * showFormMessage
	 */
	function clearFormMessages($form) {
		const $formAlertContainer = $form.find('.product-alert-container');
		$formAlertContainer.children().remove();
	}

	/**
	 * resetImagesAndThumbs
	 *
	 * @param {Number} pos
	 */
	function resetImagesAndThumbs(pos = 0) {
		const color = $productForms.find('[name*="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]').val();

		$images.removeClass('show-preview-overlay');

		$images.add($thumbs).slick('slickUnfilter');
		$images
			.add($thumbs)
			.slick('slickFilter', `[data-color${color ? `="${color}"` : ''}]`);

		setThumbsWidth();
		setActiveThumbClass(pos);

		$images.removeClass('show-preview-overlay');
		$images.slick('slickGoTo', pos, true);
		setImagesSlideHeight();

		utils.addObjectFitPolyfill();
	}

	/**
	 * setThumbsWidth
	 */
	function setThumbsWidth() {
		if (!isSingleColumn()) {
			let thumbsTotalWidth = 0;
			let slidesToShow;

			$thumbs[0].slick.$slides.each(function () {
				thumbsTotalWidth += $(this).outerWidth(true);
			});

			$thumbs.width('');

			if (thumbsTotalWidth < $thumbs.width()) {
				slidesToShow = 10;
				$thumbs.width(thumbsTotalWidth);
			} else {
				slidesToShow = 7;
			}

			$thumbs.slick('slickSetOption', 'slidesToShow', slidesToShow, true);
		}
	}

	/**
	 * setImagesSlideHeight
	 */
	function setImagesSlideHeight() {
		const $slides = $images.find('.product-images-slide').css('height', '');

		// For mobile: get the height from the tallest image (but no more than the width of the image)
		// For desktop: set height the same as the image width
		if (isSingleColumn()) {
			const imageHeights = $slides
				.map(function () {
					return $(this).find('img').height();
				})
				.get();

			$slides.height(
				Math.min($slides.width(), Math.max.apply(null, imageHeights))
			);
		} else {
			$slides.each(function () {
				var $this = $(this);
				$this.height($this.find('img').width());
			});
		}
	}

	/**
	 * setActiveThumbClass
	 *
	 * @param {Number} i
	 */
	function setActiveThumbClass(i = 0) {
		if (!isSingleColumn()) {
			$thumbs
				.find('.product-thumbs-slide')
				.removeClass('slick-real-active')
				.eq(i)
				.addClass('slick-real-active');
		}
	}

	/**
	 * accordion
	 */
	function accordion() {
		const $collapses = $product.find('.v4-product-collapse .collapse-wrapper');

		$collapses
			.on('show.bs.collapse', function () {
				$collapses.not(this).each(function () {
					$(
						'.collapse-trigger[data-target="#' +
							$(this).attr('id') +
							'"]:not(.collapsed)'
					).trigger('click');
				});
			})
			.on('shown.bs.collapse', function () {
				const pos =
					$(
						'.collapse-trigger[data-target="#' + $(this).attr('id') + '"]'
					).offset().top - $('.header-content-mobile').outerHeight();

				if ($window.scrollTop() > pos) {
					setTimeout(function () {
						$('html, body').stop(true).animate(
							{
								scrollTop: pos,
							},
							300
						);
					}, 50);
				}
			});
	}

	/**
	 * isSingleColumn
	 *
	 * @return {Boolean}
	 */
	function isSingleColumn() {
		return $window.width() < 1024;
	}

	/**
	 * Check if element is fully visible in the viewport
	 *
	 * @param {Element} el
	 *
	 * @return {Boolean}
	 */
	function isElementInViewport(el) {
		const rect = el.getBoundingClientRect();

		return (
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.left <=
				((window.innerWidth || document.documentElement.clientWidth) &&
					rect.width) &&
			rect.top <=
				((window.innerHeight || document.documentElement.clientHeight) &&
					rect.height)
		);
	}

	/**
	 * Add product list items campaign classes.
	 * Uses global campaignClassMapping and item data-campaigns attribute
	 *
	 * @param  {jQuery} $container
	 */
	function addCampaignClasses($container) {
		if (
			!window.mapping ||
			!window.mapping.campaignClass ||
			!$container.length
		) {
			return;
		}

		$container.find('[data-campaigns]:not(.cclass-added)').each(function () {
			const $item = $(this);
			const ids = String($item.data('campaigns')).split(',');
			for (let n = 0; n < ids.length; n++) {
				$item.addClass('cclass-added ' + window.mapping.campaignClass[ids[n]]);
			}
			//$item.find('.list-badges').append('<div class="list-badge day-badge">');
		});
	}

	/**
	 * Fetch user's recently viewed products carousel via AJAX and place it to the page
	 */
	function addRecentlyViewedProductsCarousel() {
		const $container = $('#recently-viewed-products');
		const userProducts = trackPages.getPage('product');

		if (userProducts && userProducts.length) {
			$.ajax({
				data: {
					type: 'recentlyViewed',
					products: userProducts,
					product: $productForms.data('identifier'),
				},
				dataType: 'text',
				method: 'GET',
				timeout: 30000,
				url: '/stage-ajax/getProductCarousel/',
			})
				.done(function (response) {
					if (response) {
						$container.html(response);
						const $carousel = $container.find('.product-carousel')

						productCarousel($carousel);
						productListItems($carousel);

						const carouselProductAmount =
							$carousel.find('.product-list-item').length;
						if (carouselProductAmount <= 2) {
							$carousel.find('.slick-track').css('margin', 'auto');
						}
					}
				})
				.fail(function (xhr) {})
				.always(function (xhr) {});
		}
	}

	/**
	 * Fetch similar products carousel via AJAX and place it to the page. DEPRECATED!
	 * Replaced with loop54 related entities carousel.
	 */
	function addCrossSellProductCarousel() {
		const $container = $('#popular-products');
		let params;
		try {
			params = JSON.parse(
				decodeURIComponent($productForms.data('product-metadata'))
			);
		} catch (e) {
			console.log(e);
		}

		if (params) {
			params.type = 'crossSell';
			$.ajax({
				data: { sapId: params.sapId, length: 4 },
				dataType: 'text',
				url: '/stage-ajax/getProductBreadcrumb/',
			}).then((res) => {
				const breadcrumbs = res?.length ? res : [];
				params.breadcrumbs = breadcrumbs;

				$.ajax({
					data: params,
					dataType: 'text',
					url: '/stage-ajax/getProductCarousel/',
				})
					.done((res) => {
						if (res) {
							$container.html(res);
							const $carousel = $container.find('.product-carousel');
							productCarousel($carousel);
							productListItems($carousel);
						}
					})
					.fail((xhr) => {});
			});
		}
	}

	/**
	 * Fetch related entities (loop54) products carousel via AJAX and place it to the page.
	 */
	function addRelatedEntitiesCarousel() {
		try {
			const { sapId = '' } = JSON.parse(
				decodeURIComponent($productForms.data('product-metadata'))
			);
			const $container = $('#related-entities-carousel');

			$.ajax({
				data: { sapId, length: 4 },
				dataType: 'text',
				url: '/stage-ajax/getProductBreadcrumb/',
			}).then((res) => {
				const breadcrumbs = res?.length ? res : [];
				const userId = loop54Connector.getId();
				const checkedColor = $('[type="hidden"][name*="color"][data-page-variant="true"], .product-colors-list input:checked').val();
				const params = {
					userId,
					product: { sapId, color: checkedColor },
					breadcrumbs,
					type: 'relatedEntities',
				};

				if (params.userId) {
					$.ajax({
						data: params,
						dataType: 'text',
						url: '/stage-ajax/getProductCarousel/',
					})
						.done((res) => {
							if (res) {
								$container.html(res);
								const $carousel = $container.find('.product-carousel');

								// add loop54Side to dataLayer for analytics
								const loop54Side = $carousel.data('loop54side');
								if (loop54Side) {
									dataLayer?.push({ loop54Side });
								}

								productCarousel($carousel);
								productListItems($carousel);
							}
						})
						.fail((xhr) => {});
				}
			});
		} catch (e) {
			console.log(e);
		}
	}

	/**
	 * Fetch complementary entities (loop54) products carousel via AJAX and place it to the page.
	 */
	function addComplementaryEntitiesCarousel() {
		const $container = $('#complementary-entities-carousel');
		const params = {};
		try {
			const userId = loop54Connector.getId();
			params.userId = userId;
			const { sapId } = JSON.parse(
				decodeURIComponent($productForms.data('product-metadata'))
			);
			const checkedColor = $('[type="hidden"][name*="color"][data-page-variant="true"], .product-colors-list input:checked').val();
			params.product = { sapId, color: checkedColor };
		} catch (e) {
			console.log(e);
		}

		if (params.userId) {
			params.type = 'complementaryEntities';
			$.ajax({
				data: params,
				dataType: 'text',
				url: '/stage-ajax/getProductCarousel/',
			})
				.done((res) => {
					if (res) {
						$container.html(res);
						const $carousel = $container.find('.product-carousel');

						// add loop54Side to dataLayer for analytics
						const loop54Side = $carousel.data('loop54side');
						if (loop54Side) {
							dataLayer?.push({ loop54Side });
						}

						productCarousel($carousel);
						productListItems($carousel);
					}
				})
				.fail((xhr) => {});
		}
	}

	/**
	 * Push new product detail view to dataLayer when user
	 * changes color in product page.
	 */
	function pushProductDetailViewToDatalayer($form) {
		const productDetail = window.productDetailDataObject;
		if (productDetail) {
			const productDetailCopy = cloneDeep(productDetail);
			const sapId = objectPath.get(
				productDetailCopy,
				'ecommerce.detail.products.0.id'
			);
			const selectedColorValue = $form
				.find('[type="hidden"][name*="color"][data-page-variant="true"], .product-colors [name="color"]:checked')
				.val();
			const dim16 = `${sapId ? sapId : ''}_${selectedColorValue}`;
			objectPath.set(
				productDetailCopy,
				'ecommerce.detail.products.0.dimension16',
				dim16
			);

			if (window.GoogleTagManager.isEnabled()) {
				window.GoogleTagManager.productDetailView(productDetailCopy);
			}
		}
	}

	/**
	 * Datalayer events
	 */
	function dataLayerEvents() {
		const isGaEnabled = utils.isGaAvailable();
		let scrollTimer;

		$document
			.on('click', '.carousel-filter', function () {
				const $elem = $(this);

				if ($elem.closest('#popular-products').length) {
					window.dataLayer.push({
						event: 'GAEvent',
						eventCategory: 'Carousel',
						eventAction: 'Select target group',
						eventLabel: $elem.text(),
					});
				}
			})
			.on('click', '.product-list-item.slick-slide', function (e) {
				const $elem = $(this);
				const eventLabel = `${$elem.find('.product-name .brand').text()} ${$elem
					.find('.product-name .name')
					.text()}`;
				const targetLocation = $elem.find('.product-link').attr('href');
				const isRelatedEntitiesCarousel =
					$elem.parents('#related-entities-carousel').length > 0;
				const isComplementaryEntitiesCarousel =
					$elem.parents('#complementary-entities-carousel').length > 0;
				const isStageCarousel = $elem.parents('#popular-products').length > 0;

				if (isStageCarousel) {
					window.dataLayer.push({
						event: 'GAEvent',
						eventCategory: 'Carousel',
						eventAction: 'Open product',
						eventLabel: eventLabel,
						eventCallback: () => (document.location = targetLocation),
						eventTimeout: 2000,
					});

					if (isGaEnabled) {
						e.preventDefault();
					}
				} else if (
					isRelatedEntitiesCarousel ||
					isComplementaryEntitiesCarousel
				) {
					const $productListItem = $elem.closest('.product-list-item');
					const { identifier } = $productListItem.data();
					const entity = { type: 'Product', id: identifier };

					loop54Connector.createEvent('click', entity, () => {
						if (isRelatedEntitiesCarousel) {
							window.dataLayer.push({
								event: 'GAEvent',
								eventCategory: 'Carousel',
								eventAction: 'Open product',
								eventLabel: eventLabel,
								eventCallback: () => (document.location = targetLocation),
								eventTimeout: 2000,
							});
						} else {
							// skip GA event for complementary entities carousel for better AB test results, remove "else" after AB test
							document.location = targetLocation;
						}
					});

					if (isGaEnabled) {
						e.preventDefault();
					}
				}
			})
			.on('click', '.slick-arrow', function () {
				const $elem = $(this);

				if ($elem.closest('#popular-products').length) {
					window.dataLayer.push({
						event: 'GAEvent',
						eventCategory: 'Carousel',
						eventAction: 'Browse products',
						eventLabel: '-',
					});
				}
			})
			.on('swipe', '.product-carousel', function () {
				const $elem = $(this);

				if ($elem.closest('#popular-products').length) {
					window.dataLayer.push({
						event: 'GAEvent',
						eventCategory: 'Carousel',
						eventAction: 'Browse products',
						eventLabel: '-',
					});
				}
			})
			.on('scroll.popularProducts', function () {
				if (scrollTimer) clearTimeout(scrollTimer);

				scrollTimer = setTimeout(function () {
					if (
						$('#popular-products').length &&
						isElementInViewport($('#popular-products')[0])
					) {
						$(document).off('scroll.popularProducts');

						window.dataLayer.push({
							event: 'GAEvent',
							eventCategory: 'Carousel',
							eventAction: 'Show carousel',
							eventLabel: 'Popular products',
						});
					}
				}, 100);
			})
			.on('click', '.product-breadcrumb-link', function () {
				window.dataLayer.push({
					event: 'GAEvent',
					eventCategory: 'Product Page',
					eventAction: 'Click Breadcrumb',
					eventLabel: $(this).text(),
				});
			});
	}
}
